import React from 'react';
import { injectIntl, defineMessages, IntlShape } from 'react-intl';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import MenuItem from '@material-ui/core/MenuItem';
import { State as RoomState } from '../../lib/reducers/room';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { IconRecord, IconStop } from '../IconSet';
import {
  startRecording,
  stopRecording
} from '../../lib/actions/room';


const messages = defineMessages({
  menuRecording: { id: 'menuRecording' },
  stopRecording: { id: 'stopRecording' },
});

type MappedProps = {
  isRecording: boolean;
  isRequestingRecordingOp: boolean;
}

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators({
    // eslint-disable-next-line @typescript-eslint/camelcase
    handleStartRecording: () => startRecording({ base_url: window.location.origin }),
    handleStopRecording: () => stopRecording(),
  },
  dispatch
  );

type State = {
  room: RoomState;
}

const mapStateToProps = (state: State): MappedProps => ({
  isRecording: state.room.isRecording,
  isRequestingRecordingOp: state.room.isRequestingRecordingOp,
});

type Props = {
  closeMenu: () => void;
} & MappedProps

type PropsType = Props & { intl: IntlShape } & ReturnType<typeof mapDispatchToProps>

function getStopRecordingIcon(props: PropsType, stopRecord: () => void) {
  const l10n = props.intl.formatMessage;
  const stopRecordingIcon = (
    <React.Fragment>
      <MenuItem onClick={stopRecord} disabled={props.isRequestingRecordingOp}>
        <ListItemIcon>
          <IconStop size={32} />
        </ListItemIcon>
        <ListItemText primary={l10n(messages.stopRecording)} />
      </MenuItem>
    </React.Fragment>
  );
  return stopRecordingIcon;
}

function getStartRecordingIcon(props: PropsType, startRecord: () => void) {
  const l10n = props.intl.formatMessage;
  const startRecordingIcon = (
    <React.Fragment>
      <MenuItem onClick={startRecord} disabled={props.isRequestingRecordingOp}>
        <ListItemIcon>
          <IconRecord size={32} />
        </ListItemIcon>
        <ListItemText primary={l10n(messages.menuRecording)} />
      </MenuItem>
    </React.Fragment>

  );
  return startRecordingIcon;
}

function RecordButton(props: PropsType) {

  const startRecord = (): void => {
    props.handleStartRecording();
    props.closeMenu();
  };

  const stopRecord = (): void => {
    props.handleStopRecording();
    props.closeMenu();
  };

  return (
    <div>
      {props.isRecording ?
        getStopRecordingIcon(props, stopRecord) :
        getStartRecordingIcon(props, startRecord)
      }
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(RecordButton));
